import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useLang } from "@/contexts/LangContext";
import PropertyCard from "@/components/PropertyCard";

export default function Favorites() {
  const { t } = useLang();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/favorites").then((r) => setItems(r.data.items || [])).finally(() => setLoading(false)); }, []);

  return (
    <div className="max-w-7xl mx-auto px-6 py-10">
      <h1 className="text-2xl sm:text-3xl font-extrabold text-emerald-950 mb-6">{t.fav.title}</h1>
      {loading ? <div className="text-center text-slate-500 py-16">{t.common.loading}</div> :
       items.length === 0 ? <div className="text-center text-slate-500 py-16 bg-white rounded-2xl border border-slate-200">{t.fav.empty}</div> :
       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
         {items.map((p) => <PropertyCard key={p.id} property={p} onFavChange={(id) => setItems((xs) => xs.filter((x) => x.id !== id))} />)}
       </div>}
    </div>
  );
}
